export default __webpack_public_path__ + "static/media/logo.2dae8e4c.png";